import { createFileRoute, redirect } from '@tanstack/react-router';
import { aiUsageSearch } from './-billing-legacy-search';

// The AI usage card on the Usage tab replaces this tab. Old bookmarks still use this URL.
export const Route = createFileRoute('/_authenticated/settings/billing/llm-usage')({
  beforeLoad: ({ location }) => {
    throw redirect({ to: '/settings/billing/usage', search: aiUsageSearch(location.search), replace: true });
  },
});
